import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getJournal } from "../lib/api";

const Journal = () => {
    const [posts, setPosts] = useState([]);

    useEffect(() => {
        getJournal().then(setPosts).catch(() => {});
    }, []);

    return (
        <div data-testid="journal-page" className="bg-[#FAF9F6]">
            <section className="py-20 lg:py-28 px-6 lg:px-10">
                <div className="max-w-4xl mx-auto">
                    <p className="label">Journal</p>
                    <h1 className="font-serif text-5xl sm:text-6xl mt-5 leading-[1.04]">
                        Quiet notes
                        <br />
                        from the bench.
                    </h1>
                    <p className="mt-8 max-w-2xl text-lg text-[#4A4A46] leading-relaxed">
                        Short, honest writing about soap making, ingredients, and the small
                        habits that make a handmade bar last.
                    </p>
                </div>
            </section>

            <section className="px-6 lg:px-10 pb-32">
                <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-16">
                    {posts.map((post) => (
                        <Link
                            key={post.slug}
                            to={`/journal/${post.slug}`}
                            data-testid={`journal-card-${post.slug}`}
                            className="group block"
                        >
                            <div className="product-image-wrap aspect-[4/3]">
                                <img
                                    src={post.image}
                                    alt={post.title}
                                    loading="lazy"
                                    className="product-image w-full h-full object-cover"
                                />
                            </div>
                            <p className="label mt-6">
                                {new Date(post.published_at).toLocaleDateString("en-AU", {
                                    day: "2-digit",
                                    month: "long",
                                    year: "numeric",
                                })}
                            </p>
                            <h2 className="font-serif text-3xl mt-3 leading-snug text-[#1C1C1A]">
                                {post.title}
                            </h2>
                            <p className="mt-3 text-[#4A4A46] leading-relaxed">
                                {post.excerpt}
                            </p>
                            <span className="mt-5 inline-block text-[12px] uppercase tracking-[0.22em] alati-link">
                                Read
                            </span>
                        </Link>
                    ))}
                </div>
            </section>
        </div>
    );
};

export default Journal;
